/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestImpact } from '../../models/request-impact';
import { ResponseImpact } from '../../models/response-impact';

export interface SaveImpacts$Params {
  id: number;
  
    /**
     * Impacts to add to activity.
     */
    body: RequestImpact
}

export function saveImpacts(http: HttpClient, rootUrl: string, params: SaveImpacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseImpact>>> {
  const rb = new RequestBuilder(rootUrl, saveImpacts.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponseImpact>>;
    })
  );
}

saveImpacts.PATH = '/rest/impact/activity/{id}';
